import { useState } from 'react'

/**
 * Custom hook to manage QR code modal state
 * @returns {object} Modal state and handlers
 */
const useQRCodeModal = () => {
  const [modalVisible, setModalVisible] = useState(false)
  const [qrCodeValue, setQrCodeValue] = useState('')

  const showModal = (url) => {
    setQrCodeValue(url)
    setModalVisible(true)
  }

  const handleCancel = () => {
    setModalVisible(false)
    setQrCodeValue('')
  }

  return {
    modalVisible,
    qrCodeValue,
    showModal,
    handleCancel
  }
}

export default useQRCodeModal
